import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import * as React from "react";
import { useSupportedDevicesData } from "../../../hooks/use_site";

export default function SolarInverterTypeSelect({ value, onChange, disabled = false }) {
  value = value !== null ? value : "";
  const { data: supportedDevices } = useSupportedDevicesData();

  return (
    <FormControl fullWidth>
      <InputLabel>Solar inverter type</InputLabel>
      <Select
        value={value}
        label="Solar inverter type"
        disabled={disabled}
        onChange={(event) => {
          onChange(event);
        }}
      >
        {(supportedDevices?.solar_inverter || []).map((device) => {
          if (device?.is_visible !== 1 || (device?.dev_only && process.env.REACT_APP_ENV === "PROD")) return null;
          return (
            <MenuItem key={device?.device_type} value={device?.device_type}>
              {device?.device_alias}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
